import * as React from 'react';
import {
  Settings,
  Check,
  X,
  AlertTriangle,
  Power,
  ShieldCheck,
} from 'lucide-react';
import { LoyaltyIndexProps } from '../../LoyaltyIndex.type';

interface StatusCardProps {
  account: LoyaltyIndexProps['account'];
  loyaltyGlobalEnabled: boolean;
  settingsPath: string;
  activeRulesCount: number;
  readinessScore: number;
}

export function StatusCard({
  account,
  loyaltyGlobalEnabled,
  settingsPath,
  activeRulesCount,
  readinessScore,
}: StatusCardProps) {
  const ready =
    account.loyaltyEnabled && loyaltyGlobalEnabled && activeRulesCount > 0;
  const activeRulesLabel =
    activeRulesCount === 1
      ? '1 regra ativa'
      : `${activeRulesCount} regras ativas`;

  return (
    <article className="loyalty-card">
      <header className="loyalty-card__header">
        <div>
          <h2 className="loyalty-card__title">
            <ShieldCheck size={20} />
            Status do Sistema
          </h2>
          <p className="loyalty-card__description">
            Verifique se a fidelidade está liberada globalmente e para esta
            conta.
          </p>
        </div>
        <a
          href={settingsPath}
          className="loyalty-button loyalty-button--secondary loyalty-button--compact"
        >
          <Settings size={16} />
          Configurações
        </a>
      </header>
      <div className="loyalty-card__body">
        <div className="loyalty-status-grid">
          <div className="loyalty-status-panel loyalty-status-panel--wide">
            <div className="loyalty-badge-row">
              {ready ? (
                <span className="loyalty-badge loyalty-badge--success">
                  <Check size={14} />
                  Pronto para os alunos
                </span>
              ) : (
                <span className="loyalty-badge loyalty-badge--warning">
                  <AlertTriangle size={14} />
                  Requer atenção
                </span>
              )}
              {account.loyaltyEnabled ? (
                <span className="loyalty-badge loyalty-badge--success">
                  <Power size={14} />
                  Conta ativa
                </span>
              ) : (
                <span className="loyalty-badge">
                  <X size={14} />
                  Conta inativa
                </span>
              )}
              {loyaltyGlobalEnabled ? (
                <span className="loyalty-badge loyalty-badge--success">
                  <Check size={14} />
                  Global ativo
                </span>
              ) : (
                <span className="loyalty-badge loyalty-badge--danger">
                  <X size={14} />
                  Global inativo
                </span>
              )}
              {activeRulesCount > 0 ? (
                <span className="loyalty-badge loyalty-badge--success">
                  <Check size={14} />
                  {activeRulesLabel}
                </span>
              ) : (
                <span className="loyalty-badge">
                  <X size={14} />
                  Sem regra ativa
                </span>
              )}
            </div>
            <p className="loyalty-muted loyalty-status-panel__text">
              {ready
                ? 'As regras ativas já podem conceder recompensas quando os eventos forem processados.'
                : `A fidelidade precisa concluir ${3 - readinessScore} requisito(s) antes de entrar em operação.`}
            </p>
          </div>
          <div className="loyalty-status-panel loyalty-status-panel--next">
            <p className="loyalty-status-panel__label">Próxima ação</p>
            <p className="loyalty-muted loyalty-status-panel__text">
              {ready
                ? 'Revise regras ativas e acompanhe recompensas concedidas.'
                : activeRulesCount > 0
                  ? 'Acesse configurações para ativar o recurso.'
                  : 'Crie ou ative uma regra de fidelidade.'}
            </p>
          </div>
        </div>
        <div className="loyalty-sr-only" aria-live="polite">
          {ready
            ? 'Programa de fidelidade pronto para os alunos.'
            : 'Programa de fidelidade requer ativação da conta, configuração global ou regra ativa.'}
        </div>
      </div>
    </article>
  );
}
